// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__c-zHO","logo":"Header_logo__16fj-","score":"Header_score__BvA4C"};